<template>
  <div class="tw-mt-5 tw-mb-5 tw-mr-9">
    <div>
      <base-advanced-select
        label="Rx Items"
        placeholder="Select one or more Rx Items"
        :options="groupedAndSortedRxItems"
        v-model="selectedRxItems"
        label-key="label"
        value-key="value"
        multiple
        class="tw-flex-grow"
      />
    </div>
  </div>
</template>

<script>
import { orderBy, isEqual } from "lodash";

export default {
  name: "EditBusinessMemberPrescriptionRxItems",
  props: {
    editRxItems: Array,
    allowedRxItems: Array,
    isSaving: Boolean,
    hideSave: Boolean,
  },
  data() {
    return {
      selectedRxItems: [],
      isUpdatingFromChild: false,
    };
  },
  computed: {
    groupedAndSortedRxItems() {
      const options = [];
      const groups = [...new Set(this.allowedRxItems.map((item) => item.productGroup))].filter(Boolean);

      groups.forEach((g) => {
        options.push({ label: g, value: g, isHeader: true });
        options.push(...orderBy(this.allowedRxItems.filter((p) => p.productGroup === g), ["label"]));
      });

      const noGroupItems = this.allowedRxItems.filter((item) => !item.productGroup);
      if (noGroupItems.length > 0) {
        options.push({ label: "Other Rx Items", value: "Other Rx Items", isHeader: true });
        options.push(...orderBy(noGroupItems, ["label"]));
      }

      return options;
    },
  },
  watch: {
    editRxItems: {
      immediate: true,
      handler(newValue) {
        if (this.isUpdatingFromChild) {
          this.isUpdatingFromChild = false;
          return;
        }

        const newSelected = Array.isArray(newValue) ? JSON.parse(JSON.stringify(newValue)) : [];

        if (!isEqual(this.selectedRxItems, newSelected)) {
          this.selectedRxItems = newSelected;
        }
      },
      deep: true,
    },

    selectedRxItems: {
      handler(newSelectedObjects) {
        const objectsToEmit = JSON.parse(JSON.stringify(newSelectedObjects));
        this.isUpdatingFromChild = true;
        this.$emit("update:editRxItems", objectsToEmit);
        this.$nextTick(() => {
          this.isUpdatingFromChild = false;
        });
      },
      deep: true,
    },
  },
  created() {
    if (Array.isArray(this.editRxItems)) {
      this.selectedRxItems = JSON.parse(JSON.stringify(this.editRxItems));
    }
  },
};
</script>
